module.exports = __webpack_public_path__ + "static/media/1017323.e906fe01.jpg";